<template>
  <template v-if="!token.revoked">
    <WdsButtonText @click="showRevokeConfirmation">
      <WdsText small primary :title="revokeTitle">
        {{ $t('Revoke') }}
        <span class="tw-sr-only">, "{{ token.name }}"</span>
      </WdsText>
    </WdsButtonText>

    <ConfirmationModal
      :show="confirmationModal.isVisible.value"
      :title="$t('Revoke Token')"
      :description="$t('Are you sure you want to revoke this token?')"
      :confirm-text="$t('Revoke')"
      :cancel-text="$t('Cancel')"
      :loading="confirmationModal.isLoading.value"
      @confirm="confirmationModal.handleConfirm"
      @cancel="confirmationModal.handleCancel"
    />
  </template>
  <WdsText v-else error>{{ $t('Revoked') }}</WdsText>
</template>

<script setup lang="ts">
import { WdsButtonText, WdsText } from '@worksome/wds-components'
import axios from 'axios'
import ConfirmationModal from '@/components/Common/ConfirmationModal.vue'
import { $t } from '@/composables/translation'
import { useConfirmationModal } from '@/composables/useConfirmationModal'
import type { OAuthToken } from '@/components/api/types'

interface Props {
  token: OAuthToken
}

const props = defineProps<Props>()

const emit = defineEmits<{
  revoked: [tokenName: string]
}>()

const confirmationModal = useConfirmationModal()

const revokeTitle = $t('Revoke ":instance"', { instance: props.token.name })

function showRevokeConfirmation(): void {
  confirmationModal.showConfirmation({
    title: $t('Revoke Token'),
    message: $t('Are you sure you want to revoke this token?'),
    confirmText: $t('Revoke'),
    cancelText: $t('Cancel'),
    type: 'error',
    onConfirm: async () => {
      await axios.delete(`/oauth/personal-access-tokens/${props.token.id}`)
      emit('revoked', props.token.name)
    },
  })
}
</script>
